// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarAdmin_navbar__T8Aks","logo":"NavbarAdmin_logo__zjVAQ","navLinks":"NavbarAdmin_navLinks__wVnEW","navItem":"NavbarAdmin_navItem__uIgVN"};